const aiPromptSettingsEnglish = {
  header: {
    title: "AI Settings",
    description: "Customize how the AI generates your LinkedIn posts"
  },
  sections: {
    profiles: {
      title: "LinkedIn Profiles",
      description: "Add links to LinkedIn profiles whose style you'd like to emulate."
    },
    products: {
      title: "Products",
      description: "Add your products or services that the AI can reference in posts."
    },
    leadMagnets: {
      title: "Lead Magnets",
      description: "Add free resources or lead magnets you want to offer in your posts."
    },
    examples: {
      title: "Examples of Good Posts",
      description: "Add examples of successful LinkedIn posts that the AI can learn from."
    },
    callToAction: {
      title: "Call-to-Action Settings",
      description: "Control how often your posts should include a call-to-action."
    },
    emoji: {
      title: "Emoji Settings",
      description: "Control how many emojis your posts should contain."
    },
    language: {
      title: "Post Language",
      description: "Choose which language your posts should be generated in. This only affects the language of the posts, not the user interface."
    }
  },
  buttons: {
    add: {
      profile: "Add Profile",
      product: "Add Product",
      leadMagnet: "Add Lead Magnet",
      example: "Add Example"
    }
  },
  modal: {
    titles: {
      addProfile: "Add LinkedIn Profile",
      editProfile: "Edit LinkedIn Profile",
      addProduct: "Add Product",
      editProduct: "Edit Product",
      addLeadMagnet: "Add Lead Magnet",
      editLeadMagnet: "Edit Lead Magnet",
      addExample: "Add Example of Good Post",
      editExample: "Edit Example of Good Post"
    },
    placeholders: {
      profile: "LinkedIn profile link (e.g. https://www.linkedin.com/in/johndoe)",
      productName: "Product name",
      productDescription: "Description of the product and its features",
      leadMagnetName: "Lead magnet name",
      leadMagnetDescription: "Description of the resource and its value",
      example: "Insert an example of a good LinkedIn post"
    },
    buttons: {
      cancel: "Cancel",
      add: "Add",
      save: "Save changes"
    }
  },
  ctaFrequency: {
    always: "Always",
    every2: "Every 2nd post",
    every3: "Every 3rd post",
    every4: "Every 4th post",
    never: "Never",
    withCta: "With CTA",
    withoutCta: "Without CTA"
  },
  emojiFrequency: {
    none: "None",
    few: "A few",
    medium: "Medium",
    many: "Many",
    examples: {
      none: "Posts without emojis.",
      few: "Few emojis 👍",
      medium: "Moderate emojis 👋 to highlight important points ✅",
      many: "Many emojis 🚀 for energetic text 🔥 that catches the eye 👀 and creates engagement 💪"
    }
  },
  preferredEmojis: {
    label: "Preferred emojis:",
    placeholder: "Enter your preferred emojis (e.g.: 🚀 ✨ 💪 🔥 👍)",
    description: "The AI will prioritize these emojis in your posts, but will still use others to ensure variety."
  },
  postLanguage: {
    examples: {
      da: "Dette er et eksempel på et opslag på dansk. AI'en vil generere indhold på dette sprog.",
      en: "This is an example of a post in English. The AI will generate content in this language.",
      no: "Dette er et eksempel på et innlegg på norsk. AI-en vil generere innhold på dette språket.",
      sv: "Detta är ett exempel på ett inlägg på svenska. AI:n kommer att generera innehåll på detta språk."
    },
    previewHeader: "Example post"
  },
  save: {
    success: "Settings saved!",
    error: "Error saving. Please try again."
  },
  customerBanner: "You are editing AI settings for {customerName}",
  about: {
    title: "About yourself",
    label: "Tell the AI about your background and expertise",
    placeholder: "Example: I'm a digital marketing consultant with 8 years of experience in e-commerce. I specialize in SEO, Google Ads, and conversion optimization. I help small and medium-sized businesses increase their online sales...",
    helpText: "This field gives the AI valuable context about your professional background, industry, and expertise. The information is used to create more relevant and authentic posts, but is not mentioned directly unless particularly relevant."
  },
  customPrompt: {
    title: "Custom System Prompt",
    description: "Add your own instructions to the AI. This is only for advanced users who want to adjust the system prompt.",
    label: "Extra instructions to the AI (optional)",
    placeholder: "Example: 'Always write in a very personal and humorous tone' or 'Focus on asking questions to readers at the end of each post'",
    warning: "Warning: This field is for advanced users. Incorrect instructions can negatively affect the quality of your posts. Leave the field empty if you're unsure."
  }
};

export default aiPromptSettingsEnglish; 